export const FETCH_SPA_VOUCHER = "FETCH_SPA_VOUCHER";
